import React from "react";
import some from "lodash/some";
import { Button, Form, Input, Icon, Alert } from "antd";
import { Toggle } from "react-powerplug";

const FormItem = Form.Item;

class LoginFormContent extends React.Component {
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.onSubmit();
  };

  render() {
    const {
      form: { getFieldDecorator, getFieldsError },
      submitting,
      error,
    } = this.props;

    const hasErrors = some(getFieldsError());

    return (
      <Form
        onSubmit={this.handleSubmit}
        layout="vertical"
        className="login-form"
      >
        {error && (
          <FormItem>
            <Alert message={error} type="error" showIcon />
          </FormItem>
        )}
        <FormItem label="Username">
          {getFieldDecorator("username", {
            rules: [{ required: true, message: "Username is required" }],
            validateTrigger: ["onBlur", "onChange"],
          })(
            <Input
              type="text"
              placeholder="Please enter your username"
              prefix={<Icon type="user" />}
            />
          )}
        </FormItem>

        <Toggle initial={false}>
          {({ on, toggle }) => (
            <FormItem label="Password">
              {getFieldDecorator("password", {
                rules: [{ required: true, message: "Password is required" }],
                validateTrigger: ["onBlur", "onChange"],
              })(
                <Input
                  type="password"
                  placeholder="Please enter your password"
                  prefix={<Icon type="lock" />}
                  suffix={
                    <Icon
                      type={on ? "eye" : "eye-invisible"}
                      onClick={toggle}
                    />
                  }
                />
              )}
            </FormItem>
          )}
        </Toggle>

        <FormItem>
          <Button
            disabled={submitting || hasErrors}
            type="primary"
            htmlType="submit"
          >
            Submit
          </Button>
        </FormItem>
      </Form>
    );
  }
}

const LoginForm = Form.create()(LoginFormContent);

class LoginView extends React.Component {
  state = {
    submitting: false,
    error: undefined,
    isMounted: false,
  };

  handleSubmit = () => {
    const { onSubmit } = this.props;
    const form = this.formRef.props.form;
    this.setState({ submitting: true });
    form.validateFields(async (error, values) => {
      if (error) {
        this.setState({ submitting: false });
        return;
      }

      const errors = await onSubmit(values);
      if (errors) {
        this.setState({
          error: errors["_error"],
          submitting: false,
        });
        form.resetFields();
      }
      //form.setFields({[field]: {value, errors: [new Error(error)]},
    });
  };

  saveFormRef = (formRef) => (this.formRef = formRef);

  render() {
    const { submitting, error } = this.state;
    return (
      <div className="c-login-view">
        <div className="c-login-view__form">
          <LoginForm
            wrappedComponentRef={this.saveFormRef}
            onSubmit={this.handleSubmit}
            submitting={submitting}
            error={error}
          />
        </div>
      </div>
    );
  }
}

export default LoginView;
